import React, { useCallback, useRef, useState, useEffect } from "react";

import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { properties } from "../../../../../data/successCases";

SwiperCore.use([Navigation, Pagination, Autoplay]);
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useTranslation } from 'next-i18next';
import { SuccessCasesComponent, SwiperCard, ContainerTopText, ContainerSwiperClientText, ContainerBottomText } from './styles';
import { useRouter } from "next/router";
import useSelectedLanguageCode from "../../../../../hooks/useSelectedLanguageCode";

const bulletStylesActive = {
  "--swiper-pagination-color": "#FFFFFF",
  "--swiper-pagination-bullet-inactive-color": "#FFFFFF",
  "--swiper-pagination-bullet-inactive-opacity": "0.5",
  "--swiper-pagination-bullet-horizontal-gap": "8px",
};

const bulletStylesInactive = {
  "--swiper-pagination-color": "transparent",
  "--swiper-pagination-bullet-inactive-color": "transparent",
};

function SuccessCases() {
  const router = useRouter();
  const { t } = useTranslation();
  const selectedLanguageCode = useSelectedLanguageCode();

  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const [selectedClient, setSelectedClient] = useState(properties[0]);
  const [nextClient, setNextClient] = useState(properties[1]);
  const [width, setWidth] = useState();


  const handleSlideChange = (swiper) => {
    const currentIndex = swiper.realIndex;
    setSelectedClient(properties[currentIndex]);
    if (currentIndex === properties.length - 1) {
      setNextClient(properties[0]);
    } else {
      setNextClient(properties[currentIndex + 1]);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setWidth(screenWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openCase = (caseId) => {
    router.push(`/${router.query.locale}/cases/${caseId}`);
  }

  return (
    <SuccessCasesComponent>
      <ContainerTopText>
        <div className="detail-line"></div>
        <p className="title">{t("cases.title")}</p>
        <p className="subtitle">{t("cases.subtitle")}</p>
      </ContainerTopText>
      <div className="text-swiper-wrapper">
        <div className="swiper-container">
          <Swiper
            ref={sliderRef}
            onClick={() => openCase(selectedClient?.id)}
            modules={[Navigation]}
            onSlideChange={(index) => handleSlideChange(index)}
            centeredSlides={true}
            pagination={{
              clickable: true,
              type: "bullets"
            }}
            loop={width < 1200 ? true : false}
            style={width < 1200 ? bulletStylesActive : bulletStylesInactive}
            slidesPerView={2}
            autoplay={{ delay: 5000 }}
          >
            {properties.map((slide) => (
              <SwiperSlide key={slide.id}>
                <SwiperCard backgroundImg={slide.backgroundImg}>
                </SwiperCard>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <ContainerSwiperClientText>
          <div className="text-pagination-wrapper">
            <ContainerBottomText>
              <p className="client-name">{selectedClient?.clientName[selectedLanguageCode]}</p>
              <p className="case">{selectedClient?.disclaimer[selectedLanguageCode]}</p>
            </ContainerBottomText>
            <button onClick={() => openCase(selectedClient?.id)}>{t("cases.button")}</button>
          </div>
          {width >= 1200 && (
            <div className="pagination">
              <div className="previous-arrow" onClick={handlePrev}>
                {selectedClient.id !== properties[0].id && <img
                  src="/landings/assets/icons/right-filled-arrow.svg"
                  className="transform-arrow arrow"
                  alt="Ícone seta para direita"
                />}
              </div>
              {selectedClient.id !== properties[properties.length - 1].id && <div className="arrow-logo-wrapper">
                <div className="logo-text-wrapper">
                  <p>{t("cases.next")}</p>
                  <h4 className="text-white client-name">{nextClient?.clientName[selectedLanguageCode]}</h4>

                </div>
                <div className="next-arrow" onClick={handleNext} style={{cursor: 'pointer'}}>
                  <img
                    src="/landings/assets/icons/right-filled-arrow.svg"
                    className="arrow"
                    alt="Ícone seta para direita"
                  />
                </div>
              </div>}
            </div>
          )}
        </ContainerSwiperClientText>
      </div>
    </SuccessCasesComponent>
  );
}

export default SuccessCases;
